/* eslint-disable camelcase */

export default api => {
  function getProducts(query) {
    return api.get(`/_svc/clapi-v1/offers${query}`);
  }
  function getProductCount(query) {
    return api.get(`/_svc/clapi-v1/offers/status/count${query}`);
  }
  function postProducts(products) {
    return api.post(`/_svc/clapi-v1/offers`, products);
  }
  function exportOffers(offers) {
    return api.post(`/_svc/clapi-v1/offers/export`, offers);
  }
  function exportPSku() {
    return api.get(`/_svc/slapi-v1/reports/export/sku-unique`);
  }
  function activateOffers(products) {
    return api.put(`/_svc/clapi-v1/offers/activate`, products);
  }
  function deleteOffers(products) {
    return api.put(`/_svc/clapi-v1/offers/delete`, products);
  }
  function importOffers(offers) {
    return api.post(`/_svc/slapi-v1/upload/file`, offers);
  }
  function importPSkuUnique(file) {
    return api.post(`/_svc/slapi-v1/sku-unique/import`, file);
  }
  return {
    getProducts,
    postProducts,
    exportOffers,
    activateOffers,
    deleteOffers,
    importOffers,
    importPSkuUnique,
    exportPSku,
    getProductCount
  };
};



// WEBPACK FOOTER //
// ./src/services/ProductsService.js